@if (data) {
    <div class="popup-dialog" [attr.data-testid]="popupId">
        <!-- Start Title Bar -->
        <div class="popup-dialog__top">
            <h1 class="h3">{{ data.ticketnumber }}</h1>
            <button mat-icon-button aria-label="Luk dialog" (click)="closeCaseDialog()" class="popup-dialog__button" role="button" type="button">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
        </div>
        @if (isLoading) {
            <mat-spinner class="loading"></mat-spinner>
        }
        <div class="mat-form" [class]="isLoading ? 'is-loading' : ''" [attr.data-testid]="caseForm">
            <div class="mat-form__top">
                @if (account.reportedBy) {
                    <div class="mat-form__name mb-4">
                        <span class="h4 mb-1"> {{ getDictionaryItem("reportedBy") }} </span>
                        <span> {{ account.reportedBy }} </span>
                    </div>
                }
                <div class="mb-4">
                    @if (data.statuscode === 922520000) {
                        <button (click)="this.showCloseWarning = true" mat-button class="cta-button" type="button" [attr.data-testid]="closeCaseDialogButton">
                            <span> {{ getDictionaryItem("closeCase") }} </span>
                        </button>
                    }
                </div>
            </div>
            @if (data.dueDate) {
                <div class="mat-form__name mb-4">
                    <span class="h4 mb-1"> Sagen er planlagt til </span>
                    <span> {{ data.dueDate | date: "dd-MM-yyyy kl. HH:mm" }} </span>
                </div>
            }
            @if (account.account) {
                <div class="mat-form__name mb-4">
                    <span class="h4 mb-1"> {{ getDictionaryItem("belongingTo") }} </span>
                    <span> {{ account.account }} </span>
                </div>
            }
            @if (businessArea) {
                <div class="mb-4">
                    <span class="h4 mb-1"> {{ getDictionaryItem("area") }} </span>
                    <span>{{ businessArea }}</span>
                </div>
            }
            @if (category) {
                <div class="mb-4">
                    <span class="h4 mb-1"> {{ getDictionaryItem("category") }} </span>
                    <span>{{ category }}</span>
                </div>
            }
            <div class="mb-4">
                <span class="h4 mb-1"> {{ getDictionaryItem("headline") }} </span>
                <span> {{ data.title }} </span>
            </div>
            <div>
                <div class="edit-case-description">
                    <span id="case-text-edit-label" class="h4 mb-1"> {{ getDictionaryItem("description") }} </span>
                    @if (data.statuscode === 922520000) {
                        <button mat-button class="cta-button mb-4" (click)="editCase()">{{ isEditing ? "Annuller redigering" : "Rediger sag" }}</button>
                    }
                </div>
                @if (data.description && !isEditing) {
                    <div [innerHTML]="data.description" id="case-description" aria-labelledby="case-text-area" class="case-description text-default" tabindex="-1"></div>
                } @else if (isEditing) {
                    <textarea
                        id="case-text-area"
                        class="case-description"
                        [innerHTML]="data.description"
                        aria-labelledby="case-text-edit-label"
                        tabindex="0"
                        (paste)="pasteFilesToImageGallery($event)"
                        #caseTextArea
                    ></textarea>
                } @else if (!data.description) {
                    <span>
                        {{ getDictionaryItem("noDescription") }}
                    </span>
                }
            </div>
            @if ((images.length > 0 && images) || isEditing) {
                <app-image-gallery
                    #imageGallery
                    class="mt-4"
                    (newAnnotations)="eventNewAnnotation($event)"
                    (removeAnnotations)="eventRemoveAnnotation($event)"
                    [caseImages]="images"
                    [isEditing]="isEditing && data.statuscode === 922520000 ? true : false"
                    [isCaseDetail]="true"
                ></app-image-gallery>
            }
            @if (data.solution) {
                <div class="mat-form__solution">
                    <div class="mat-form__solution-text">
                        <span class="h4 mb-2">{{ getDictionaryItem("solution") }} </span>
                        <div [innerHTML]="data.solution" style="white-space: pre-line"></div>
                    </div>
                </div>
            }

            @if (isEditing && data.statuscode === 922520000) {
                <button mat-button class="cta-button" (click)="updateEditedCase()" role="button" type="submit">Godkend ændringer</button>
            }
        </div>
        @if (showCloseWarning) {
            <div
                class="popup-dialog__warning-dialog"
                [class]="isLoading ? 'is-loading' : ''"
                [attr.data-testid]="popupWarning"
                cdkTrapFocus
                [cdkTrapFocusAutoCapture]="true"
                role="dialog"
                aria-labelledby="close-warning"
            >
                <div id="close-warning" class="popup-dialog__warning-dialog-content">
                    <span class="text-default">{{ getDictionaryItem("closeCaseWarningText") }} </span>
                    <button mat-button (click)="this.showCloseWarning = false" role="button" type="button">Nej</button>
                    <button mat-button class="cta-button" (click)="closeCase()" role="button" type="button">Ja</button>
                </div>
            </div>
        }
    </div>

    @if (showMessageCenter) {
        <app-message-center [data]="messageCenter" [state]="messageCenterState" [progressCount]="5000" [isFixed]="true"></app-message-center>
    }
}
